import { EntityTypeEnum, PermissionEnum } from '@sr-sdks/api-sdk-axios';
import { Alert } from '@sr/ui-library';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCurrentUserAuth } from '../../../hooks/useCurrentUserAuth';
import { reduxServices } from '../../../reducers/reduxServices';
import { useTypedSelector } from '../../../stateStore';

/**
 * Workspace owner and admin will see the unverified business alerts.
 *
 * @deprecated This component will be replaced soon.
 */
const AlertsForUnverifiedBusinesses = () => {
  const navigate = useNavigate();
  const { auth, currentUser } = useCurrentUserAuth();

  const workspaces = useTypedSelector(
    reduxServices.workspace.selectors.workspaces,
  );

  const unverifiedBusinesses = workspaces?.filter(
    (workspace) =>
      !workspace.businessNumberVerified &&
      workspace.businessNumberCountry === 'AU' &&
      workspace.entityType === EntityTypeEnum.Company,
  );

  const shouldShowUnverifiedBusinessAlert = useMemo(
    () =>
      auth?.currentUserHasPermission(PermissionEnum.EditWorkspaceDetails) &&
      unverifiedBusinesses.length > 0,
    [unverifiedBusinesses.length, currentUser],
  );

  if (!shouldShowUnverifiedBusinessAlert) return null;

  return unverifiedBusinesses.map((v, index) => (
    <Alert
      key={index}
      actionButtonProps={{
        children: 'Verify Now',
        onClick: () => navigate(`/workspace/${v._id}/manage-workspace/details`),
      }}
      className="xl:mx-auto xl:max-w-6xl"
      hasActionButton
      variant="warning"
    >
      The ABN on your workspace <strong>{v.workspaceName}</strong> cannot be
      verified. Please check your business details so that we can continue to
      process your payments. If you require further assistance, contact
      support@screenrights.org.
    </Alert>
  ));
};

export default AlertsForUnverifiedBusinesses;
